import './wide-image.scss';